import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { APP_ENVIRONMENT } from "../lib/config";
import { HelpPanel } from "../components/HelpPanel";

const navLink = ({ isActive }: { isActive: boolean }) =>
  `text-sm font-medium transition-colors ${isActive ? "text-indigo-700" : "text-gray-600 hover:text-gray-900"}`;

/** Environment badge — hidden in Production on the client portal (per frontend-ui-system.md). */
function EnvBadge() {
  const env = APP_ENVIRONMENT.toLowerCase();
  if (env === "production" || env === "prod") return null;
  const isStaging = env === "staging";
  const cls = isStaging
    ? "bg-amber-100 text-amber-700 border-amber-300"
    : "bg-green-100 text-green-700 border-green-300";
  return (
    <span className={`rounded-full border px-2 py-0.5 text-xs font-semibold ${cls}`}>
      {isStaging ? "STAGING" : "DEV"}
    </span>
  );
}

export default function PublicLayout() {
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <div className="flex min-h-screen flex-col bg-gray-50 text-gray-900">
      <header className="sticky top-0 z-10 border-b border-gray-200 bg-white">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-lg font-semibold tracking-tight text-gray-900">
              Greatway Patios
            </Link>
            <EnvBadge />
          </div>
          <nav className="flex items-center gap-6">
            <NavLink to="/" end className={navLink}>
              Home
            </NavLink>
            <NavLink to="/enquire" className={navLink}>
              Enquire
            </NavLink>
            <button
              type="button"
              onClick={() => setHelpOpen(true)}
              className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
              aria-label="Open help"
            >
              Help
            </button>
          </nav>
        </div>
      </header>

      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-gray-200 bg-white">
        <div className="mx-auto flex max-w-5xl flex-col gap-1 px-4 py-6 text-xs text-gray-500 sm:flex-row sm:justify-between">
          <p>&copy; {new Date().getFullYear()} Greatway Patios. All rights reserved.</p>
          <p>
            We handle your details in line with our privacy commitments. Enquiries are used only to
            prepare your quote.
          </p>
        </div>
      </footer>
    </div>
  );
}
